<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      fixed
      fab
      bottom
      right
      color="primary"
      slot="activator"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gästeliste Erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Titel"
                  v-model="group.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()">Erstellen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'DlgGroupNew',
    data() {
      return {
        dialog: false,
        group: {},
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    computed: {
      ...mapGetters({
        advisors: 'advisor/all',
      }),
    },
    methods: {
      ...mapActions({
        createGroup: 'admin/groups/create',
        readGroups: 'admin/groups/read',
        readAdvisors: 'admin/advisors/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.createGroup(this.group).then((success) => {
            this.loading = false;
            if (success) {
              this.group = {};
              this.readGroups();
              this.dialog = false;
              this.valid = true;
            }
          });
        }
      },
      cancel() {
        this.dialog = false;
        this.group = {};
      },
    },
  };
</script>

<style scoped>

</style>
